import {
  OnInit,
  Component,
  Inject,
} from 'ng-metadata/core';

import { CartService } from 'services/cart.service';

import orderSummaryHtml from './order-summary.html';
import * as $ from 'jquery';

@Component({
  selector: 'gw-order-summary',
  template: orderSummaryHtml,
})
export class OrderSummaryComponent implements OnInit {
  public state = {
    open: false,
  };
  public laroute = (<any>window).laroute;

  constructor(
    @Inject('$filter') private $filter,
    @Inject(CartService) private cartService: CartService,
  ) {}

  ngOnInit() {

  }

  toggle($event) {
    if ($event.target.className !== 'edit-cart') {
      this.state.open = !this.state.open;
    }
  }

  total(): string {
    const total = this.cartService.getOrderTotal();

    return this.$filter('currency')(total);
  }

  getCartUrl(): string {
    return this.laroute.route('checkout.cart');
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/common/order-summary/order-summary.component.ts